module.exports = __webpack_public_path__ + "static/media/training-level.cfc632c1.svg";